import PluginBase from './base-plugin/plugin';

export const BasePlugin = PluginBase;
export default BasePlugin;



/** WEBPACK FOOTER **
 ** ../src/index.js
 **/